import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-arabic-keyboard',
  standalone: false,
  templateUrl: './arabic-keyboard.component.html',
})
export class ArabicKeyboardComponent {
  @Input() value: string = '';
  @Input() active: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();

  arabicKeyboardLayout = [
    ['ض', 'ص', 'ث', 'ق', 'ف', 'غ', 'ع', 'خ', 'ح', 'ج', 'د'],
    ['ش', 'س', 'ي', 'ب', 'ل', 'ا', 'ت', 'ن', 'م', 'ك', 'ط'],
    ['ئ', 'ء', 'ؤ', 'ر', 'ى', 'ة', 'و', 'ز', 'ظ', '.', '،'],
  ];

  addCharacter(char: string): void {
    this.value = (this.value || '') + char;
    this.valueChange.emit(this.value);
  }

  removeLastCharacter(): void {
    this.value = (this.value || '').slice(0, -1);
    this.valueChange.emit(this.value);
  }

  close(): void {
    this.closed.emit();
  }
}
